import React, { Component } from 'react';
import './Onboarding.scss';
import { steps } from '../../../copy'
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'react-router'

class Onboarding extends Component {

    constructor(props) {
        super(props);
        this.state ={
            step: 0,
            steps: [
                {
                    title: <FormattedMessage id='onboarding.latest.title' />,
                    icon: 'icon-latest',
                    brief: <FormattedMessage id='onboarding.latest.brief' />,
                    url: '/latest',
                    pointer: 'pointer-left',
                    style: {
                        transform: `translate(890px, 100px)`
                    }
                },
                {
                    title: <FormattedMessage id='onboarding.search.title' />,
                    icon: 'icon-latest',
                    brief: <FormattedMessage id='onboarding.search.brief' />,
                    //Discover the favourite music of the best DJs, producers, artists and nightclubs. See what they’ve been sharing and build your collection.
                    url: '/latest',
                    pointer: 'pointer-top',
                    style: {
                        transform: `translate(970px, 80px)`
                    }
                },
                {
                    title: <FormattedMessage id='onboarding.collections.title' />,
                    icon: 'icon-latest',
                    //brief: 'Start searching through the best music that is shared by social pages and get never ending inspiration for your DJ sets.',
                    brief: <FormattedMessage id='onboarding.collections.brief' />,
                    //This is Groove Armadas Audio Underground page, you can see what music they perosnally share on social media below and filter music by most, liked, most commnted or currently trending.
                    url: '/page/79911571668',
                    pointer: 'pointer-bottom',
                    style: {
                        transform: `translate(210%, 90px)`
                    }
                },
                {
                    title: <FormattedMessage id='onboarding.connections.title' />,
                    icon: 'icon-latest',
                    brief: <FormattedMessage id='onboarding.connections.brief' />,
                    url: '/page/79911571668',
                    pointer: 'pointer-left',
                    style: {
                        transform: `translate(979px, 380px)`
                    }
                },
                {
                    title: <FormattedMessage id='onboarding.subscribe.title' />,
                    icon: 'icon-latest',
                    brief: <FormattedMessage id='onboarding.subscribe.brief' />,
                    url: '/page/292932115581',
                    pointer: 'pointer-top',
                    style: {
                        transform: `translate(947px, 264px)`
                    }
                },
                {
                    title: <FormattedMessage id='onboarding.discover.title' />,
                    icon: 'icon-latest',
                    brief: <FormattedMessage id='onboarding.discover.brief' />,
                    url: '/discover/0/0/-KegvwcAeXCXyrKjisoz',
                    pointer: 'pointer-left',
                    style: {
                        transform: `translate(1037px, 84px)`
                    }
                },
                {
                    title: <FormattedMessage id='onboarding.create.title' />,
                    icon: 'icon-latest',
                    brief: <FormattedMessage id='onboarding.create.brief' />,
                    url: '/mixes',
                    pointer: 'pointer-left',
                    style: {
                        transform: `translate(950px, 93px)`
                    }
                }
            ]
        }
    };

    componentDidMount() {
        //browserHistory.push(this.state.steps[0].url);
    }

    _switchFeature(step) {
        if (step === this.state.steps.length) {
            browserHistory.push("/latest");
            // setTimeout(function () {
            //     this.props.tour();
            //     this.props.showPayment();
            // }.bind(this), 500);
            // this.setState({
            //     show: false
            // });
            this.props.tour();
            return false;
        }
        let timer = 0;
        if (this.state.steps[this.state.step].url != this.state.steps[step].url) {
            let timer = 1000;
        }
        browserHistory.push(this.state.steps[step].url);
        setTimeout(function () {
            this.setState({step: step});
        }.bind(this), timer);
    }

    _endTour() {
        this.setState({
            show: false
        });
    }

    render() {

        const steps = this.state.steps.map(function (item, id) {
            let activeClass = (this.state.step === id ? 'current ' : ' ');
            let curr = (this.state.step > id ? 'active ' : ' ');
            return (
                <li key={'ind' + id} className={curr + ' ' + activeClass}></li>
            )
        }, this);

        return (
            <div>
                <div className={'onboarding ' + this.state.steps[this.state.step].pointer} style={this.state.steps[this.state.step].style}>
                    <span className="pointer arrrow-top"></span>
                    <span className="pointer arrrow-right"></span>
                    <span className="pointer arrrow-bottom"></span>
                    <span className="pointer arrrow-left"></span>
                    <div className="inner">
                        <h2 className="m-0">
                            {this.state.steps[this.state.step].title}
                            <i className={this.state.steps[this.state.step].icon + " pull-right m-0"} />
                        </h2>
                        <p className="m-t-xs m-b-xs">{this.state.steps[this.state.step].brief}</p>
                        <div className="clear"></div>
                        <ul className="m-t-md indicator">
                            {steps}
                        </ul>
                        <div className="clear"></div>
                        <div className="m-t-md">
                            <div className="row">
                                <div className="col-xs-3">
                                    <h4><span className="step">{this.state.step+1}/{this.state.steps.length}</span></h4>
                                </div>
                                <div className="col-xs-9">
                                    <ul className="controls list-inline text-right">
                                        { this.state.step > 200 &&
                                            <li><h4><a onClick={this.props.tour.bind(this)} className="muted">Skip Tour</a></h4></li>
                                        }
                                        <li><h4><a onClick={this._switchFeature.bind(this, this.state.step+1)} className="active-link">Continue Tour<i className="icon-chevron-thin-right" /></a></h4></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default Onboarding;



// WEBPACK FOOTER //
// ./src/views/components/Onboarding/index.js